// External
import React from 'react';
import { func, shape } from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { NikeDesignSystemProvider } from '@nike/nike-design-system-components';

// Internal
import Router from './app/Router';
import Root from './app/Root';

// Constants
const storeProps = {
  dispatch: func,
  getState: func,
  replaceReducer: func,
  subscribe: func
};

const defaultStoreProps = {
  dispatch: null,
  getState: null,
  replaceReducer: null,
  subscribe: null
};

const App = ({ store }) => (
  <ReduxProvider store={store}>
    <NikeDesignSystemProvider>
      <Router component={Root} />
    </NikeDesignSystemProvider>
  </ReduxProvider>
);

App.defaultProps = {
  liftedStore: { ...defaultStoreProps },
  ...defaultStoreProps
};

App.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  liftedStore: shape({
    ...storeProps
  }),
  ...storeProps
};

export default App;
